  <template>
  <div id="home">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg3 sm6 xs12>
          <v-card class="ma-3">
            <v-list-item>
                <v-sheet class="mt-n12" color="green" width="50" height="50" elevation="1">
                  <v-icon dark large class="icondash">account_circle</v-icon>
                </v-sheet>
              <v-list-item-content>
                <div class="text-right mb-2">Total Agen</div>
                <v-list-item-title class="headline mb-1 text-right">{{ formatAngka(dashboard.totalagen) }}
                </v-list-item-title>
                <div>
                  <v-divider></v-divider>
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-card-actions>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex lg3 sm6 xs12>
          <v-card class="ma-3">
            <v-list-item>
                <v-sheet class="mt-n12" color="deep-orange" width="50" height="50" elevation="1">
                  <v-icon dark large  class="icondash">record_voice_over</v-icon>
                </v-sheet>
              <v-list-item-content>
                <div class="text-right mb-2">Agen Aktif Hari ini</div>
                <v-list-item-title class="headline mb-1 text-right">{{ formatAngka(dashboard.agenaktiftoday) }}
                </v-list-item-title>
                <div>
                  <v-divider></v-divider>
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-card-actions>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex lg3 sm6 xs12>
          <v-card class="ma-3">
            <v-list-item>
              <v-sheet class="mt-n12" color="purple" width="50" height="50" elevation="1">
                <v-icon dark large  class="icondash">mail</v-icon>
              </v-sheet>
              <v-list-item-content>
                <div class="text-right mb-2">TOKEN SMS</div>
                <v-list-item-title class="headline mb-1 text-right">{{ formatAngka(dashboard.tokensms) }}
                </v-list-item-title>
                <div>
                  <v-divider></v-divider>
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-card-actions>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex lg3 sm6 xs12>
          <v-card class="ma-3">
            <v-list-item>
              <v-sheet class="mt-n12" color="deep-purple" width="50" height="50" elevation="1">
                <v-icon dark large  class="icondash">account_balance_wallet</v-icon>
              </v-sheet>
              <v-list-item-content>
                <div class="text-right mb-2">Saldo IRSMarket</div>
                <v-list-item-title class="headline mb-1 text-right">{{ formatAngka(dashboard.irsmarketbalance) }}
                </v-list-item-title>
                <div>
                  <v-divider></v-divider>
                </div>
              </v-list-item-content>
            </v-list-item>
            <v-card-actions>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <h2 class="mb-2">Video Tutorial</h2>
      <div style="display: flex;gap: 10px;flex-wrap: wrap" class="justify-center justify-space-between">
        <div class="lg3 sm6 xs12">
          <iframe width="425" height="275" src="https://www.youtube.com/embed/fukH9Pl0_OM?si=UMt5FjHLq53Cl29V" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
        <div class="lg3 sm6 xs12">
          <iframe width="425" height="275" src="https://www.youtube.com/embed/U0ZHHO8Ml1I?si=4tq7qPs2Mu2fYKq5" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
        <div class="lg3 sm6 xs12">
          <iframe width="425" height="275" src="https://www.youtube.com/embed/Kd5VPyuF_FU?si=CqgPK91LTEEe1n4C" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  components: {
  },
  data: () => ({
    contain: true,
    token: localStorage.getItem("token"),
    id: '',
    name: '',
    imgprofile: '',
    items: [
      {
        src: '/static/banner/banner2.jpg'
      },
      {
        src: '/static/banner/banner1.jpg'
      },
      {
        src: '/static/banner/banner0.jpg'
      }
    ]
  }),
  created () {

  },
  mounted () {
    console.log(this.token);
    if (this.token) {
      this.$store.dispatch("applikasi/getApplist");
      this.getDashboard();
      this.DeleteAkun()
    }else{
      this.logout()
    }
  },
  computed: {
    ...mapState({
      account: state => state.account,
      AdminMitraModule: state => state.AdminMitraModule
    }),
    ...mapState('Dashboard',['dashboard'])
  },
  methods: {
    ...mapActions({
      clearAlert: 'alert/clear',
      getme: 'account/getme',
      logout: 'account/logout',
      getDashboard: 'Dashboard/getDashboard',
      DeleteAkun: "DeleteAkun/getCountPending"
    }),
    formatAngka(angka) {
      var rev = parseInt(angka, 10).toString().split('').reverse().join('');
      var rev2 = '';
      for (var i = 0; i < rev.length; i++) {
        rev2 += rev[i];
        if ((i + 1) % 3 === 0 && i !== (rev.length - 1)) {
          rev2 += '.';
        }
      }
      return rev2.split('').reverse().join('').toString();
    }
  }
}
</script>

<style lang="stylus" scoped>
.caro {
  height: 265px;
}
  .icondash {
    margin-left: 6px;
    margin-top 5px;
  }
</style>
